import React, { useState, useEffect } from 'react';
import './ImageViewer.css';

export default function ImageViewer({ images, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  console.log('ImageViewer received images:', images);
  console.log('ImageViewer currentIndex:', currentIndex);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      } else if (e.key === 'ArrowRight') {
        setCurrentIndex((prevIndex) => 
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      } else if (e.key === 'ArrowLeft') {
        setCurrentIndex((prevIndex) => 
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [images?.length, onClose]);

  // Early return if no images or images is not an array (after hooks)
  if (!images || !Array.isArray(images) || images.length === 0) {
    console.log('ImageViewer: No valid images provided, returning null');
    return null;
  }

  const currentImage = images[currentIndex];
  
  // Additional safety check for currentImage
  if (!currentImage) {
    console.log('ImageViewer: No current image found, returning null');
    return null;
  }
  
  // Check if currentImage has a valid URL
  const imageUrl = currentImage.url || currentImage;
  if (!imageUrl) {
    console.log('ImageViewer: No valid URL in current image, returning null');
    return null;
  }

  const nextImage = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="image-viewer-overlay" onClick={onClose}>
      <div className="image-viewer-content" onClick={(e) => e.stopPropagation()}>
        <button className="image-viewer-close" onClick={onClose}>
          ×
        </button>
        
        {images.length > 1 && (
          <button className="image-viewer-nav image-viewer-prev" onClick={prevImage}>
            ‹
          </button>
        )}
        
        <div className="image-viewer-main">
          <img 
            src={imageUrl} 
            alt={`Image ${currentIndex + 1}`}
            className="image-viewer-image"
          />
        </div>
        
        {images.length > 1 && (
          <button className="image-viewer-nav image-viewer-next" onClick={nextImage}>
            ›
          </button>
        )}
        
        {images.length > 1 && (
          <div className="image-viewer-counter">
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>
    </div>
  );
} 